var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news_index"},[_c('HKPage',{attrs:{"title":_vm.title,"banner":_vm.banner}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }